import * as segmentio from 'rp-analytics';
import { getQueryParams } from './helpers/location';

const tab2section1 = {
    profiles: 'Profiles',
    stories: 'Stories',
};

const state = {
    section1: null,
};

export default function analyticsPage() {
    const queryParams = getQueryParams();
    const tab = queryParams && queryParams.tab ? queryParams.tab : 'profiles';
    const section1 = tab2section1[tab];

    if (state.section1 && state.section1 === section1) {
        return;
    }
    state.section1 = section1;

    segmentio.setCommonTraits({
        [segmentio.TRAIT_SITE_SECTION]: 'Search',
        [segmentio.TRAIT_SITE_SUB_SECTION_1]: section1,
        [segmentio.TRAIT_SITE_SUB_SECTION_2]: null,
    });

    segmentio.page();
}



// WEBPACK FOOTER //
// ./src/js/analyticsPage.js